import React, { useState } from "react";
import { connect } from 'react-redux';
import { EaseDrawer } from "../../libs/EaseDrawer";
import { Text1, Text3, Text4, Text5 } from "../../styles";
import { Descriptions, Badge, Spin } from "antd";
import { handleApiExceptions, printRupee } from "../../app_methods";
import { DISBURSEMENTS_STATUS_TYPES } from "../../constants";
import moment from 'moment';
import { Alert } from "antd";


const DisbursementDetailsDrawer = (props) => {
    const disbursementDetails = props.disbursement;
    const [isRetrieving, setIsRetrieving] = useState(false);

    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>
                    {disbursementDetails && 
                        disbursementDetails.disbursement_type == "settlement" ? 
                        "Settlement" : 
                        disbursementDetails.disbursement_type == "refund" ?
                        "Refund" : 
                        disbursementDetails.disbursement_type == "loan_repayment" ?
                        "Loan Repayment" : 
                        "Chargeback"
                    } Details
                </Text1>
                <Text5 copyable>{disbursementDetails.id}</Text5>
            </div>
        )
    };

    const renderDetails = () => {
        return (
            <Descriptions className="mb-4" title={false} column={1} bordered size="small">
                <Descriptions.Item label="Created At">{disbursementDetails.created_at && moment(disbursementDetails.created_at).format("LLL")}</Descriptions.Item>
                <Descriptions.Item label="Amount">{printRupee(disbursementDetails.amount)}</Descriptions.Item>
                <Descriptions.Item label="Payment Mode">{disbursementDetails.payment_mode}</Descriptions.Item>
                {
                    disbursementDetails.transfer_date ?
                        <Descriptions.Item label="Transfer Date">
                            {disbursementDetails.transfer_date && moment(disbursementDetails.transfer_date).format("LLL")}
                        </Descriptions.Item> : null
                }
                {
                    disbursementDetails.status ?
                        <Descriptions.Item label="Status">
                            <div className="w-100 d-flex justify-content-between align-items-center">
                                <Badge
                                    color={DISBURSEMENTS_STATUS_TYPES[disbursementDetails.status].color}
                                    text={<Text4>{DISBURSEMENTS_STATUS_TYPES[disbursementDetails.status].label}</Text4>}
                                />
                            </div>
                        </Descriptions.Item>
                        :
                        null
                }
                {
                    disbursementDetails.failure_reason ? 
                        <Descriptions.Item label="Failure Reason">{disbursementDetails.failure_reason || '---'}</Descriptions.Item>
                        :
                        null

                }
                <Descriptions.Item label="Unique Transaction Reference">{disbursementDetails.unique_transaction_reference || "---"}</Descriptions.Item>
                <Descriptions.Item label="Narration">{disbursementDetails.narration || "---"}</Descriptions.Item>
                <Descriptions.Item label="Beneficiary Name">{disbursementDetails.beneficiary_account_name || "---"}</Descriptions.Item>
                {
                    disbursementDetails.payment_mode == "UPI" ?
                        <Descriptions.Item label="UPI Handle">{disbursementDetails.beneficiary_upi_handle || "---"}</Descriptions.Item>
                        :
                        <>
                            <Descriptions.Item label="Account Number">{disbursementDetails.beneficiary_account_number || "---"}</Descriptions.Item>
                            <Descriptions.Item label="IFSC Code">{disbursementDetails.beneficiary_account_ifsc || "---"}</Descriptions.Item>
                            <Descriptions.Item label="Bank Name">{disbursementDetails.beneficiary_bank_name || "---"}</Descriptions.Item>
                        </>
                }
                <Descriptions.Item label="Platform Charges">{printRupee(disbursementDetails.service_charge, 3) || printRupee(0)}</Descriptions.Item>
                <Descriptions.Item label="GST">{printRupee(disbursementDetails.gst_amount, 3) || printRupee(0) }</Descriptions.Item>
                <Descriptions.Item label="Total Charges">{printRupee(disbursementDetails.service_charge_with_gst, 3) || printRupee(0) }</Descriptions.Item>
            </Descriptions>
        )
    };

    const renderTransactionDetails = () => {
        const transactionDetails = disbursementDetails.custom_va_transaction;
        return (
            <>
                <Text3 className="d-block" style={{ marginBottom: '8px', color: 'black' }} strong>Refund against following Transaction:</Text3>
                <Descriptions className="mb-4" column={1} size="small" bordered>
                    <Descriptions.Item label="Virtual Account">
                        <div>{transactionDetails.virtual_account.label || "---"}</div>
                        <div>{transactionDetails.virtual_account.virtual_account_number || "---"}</div>
                    </Descriptions.Item>
                    <Descriptions.Item label="Amount">{(transactionDetails.amount && printRupee(transactionDetails.amount)) || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Unique Transaction Reference">{transactionDetails.unique_transaction_reference || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Transaction Date">{(transactionDetails.transaction_date && moment(transactionDetails.transaction_date).format("LLL")) || "---"}</Descriptions.Item>
                </Descriptions>
            </>
        )
    };

    return (
        <EaseDrawer
            title={false}
            width={500}
            visible={props.visible}
            onClose={props.onClose}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div className="mt-3">
                {renderTitle()}
                {
                    isRetrieving ?
                        <div className="h-100 w-100 d-flex justify-content-center align-items-center"><Spin spinning={true} tip="Fetching details..." /></div>
                        :
                        <>
                            {renderDetails()}
                            {props.disbursement.via_capture_flow && 
                                <Alert className="mb-2"
                                    message={
                                    <>
                                        <strong>Note</strong> : Auto refunded via transaction capture flow.
                                    </>
                                    }
                                    type="info"
                                />
                            }
                            {disbursementDetails.disbursement_type == "refund" ? renderTransactionDetails() : null}
                        </>
                }
            </div>
        </EaseDrawer>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

export default connect(mapStateToProps, null)(DisbursementDetailsDrawer);